import React from "react";
import { View } from "react-native";
import Modal from "modal-enhanced-react-native-web";
import { colors } from "../../../const";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { PrimaryTitle } from "../../labels";
import Button from "../../form/Button";


export default function SuccessDialog({ onCancel, title, buttonTitle, buttonAction, ...other }) {


    return (
        <Modal
            animationIn="fadeIn"
            animationOut="bounceOut"
            backdropOpacity={0.4}
            style={{justifyContent:"center", alignItems: "center"}}
            {...other}
        >
            <View style={{ backgroundColor: colors.white, borderRadius: 10, justifyContent: "center", alignItems: "center", paddingBottom: 40, paddingHorizontal: 40 }}>

                <Icon
                    icon={faTimesCircle}
                    color={colors.midnightBack}
                    style={{ right: 10, position: "absolute", top: 10, fontSize: 20 }}
                    onClick={onCancel}
                />

                <View style={{ marginVertical: 40 }}>
                    <Icon
                        icon={faCheckCircle}
                        color={colors.green}
                        style={{ alignSelf: "center", marginBottom: 20, marginTop: 20, position: "static", fontSize: 65 }}
                    />
                    <View style={{ height: 10 }} />
                    <PrimaryTitle align="center">
                        {title}
                    </PrimaryTitle>
                </View>
                <View style={{ width: "100%", paddingHorizontal: 35 }}>

                    <Button
                        title={buttonTitle}
                        onPress={buttonAction}
                        size="small"
                    />
                </View>
            </View>
        </Modal>
    )
}